export const getKeywordPlannerStyles = () => ({
  dataContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: '100%',
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});
